import React from 'react';
import { imgUrl } from '../../utils/url';
import { useTranslation } from 'react-i18next';

const CommentCountComp = () => {
    const { t } = useTranslation();
    return(
        <div
            className="cmt-comments-access"
            title="Use alt+0 keyboard shortcut in the editor for accessibility help"
            aria-label="Use alt+0 keyboard shortcut in the editor for accessibility help"
            aria-labelledby="terms-of-service"
            role="tooltip"
            id="ckeditor-tooltip"
        >
            <img
                src={imgUrl('/images/icons/accessibility-logo-human.svg')}
                className="access-logo-human"
                aria-hidden="true"
                alt="Accessibility Logo"
            />
            <div className="cmt-access-lable">{t('Accessibility')}</div>
        </div>
    )
}

export default CommentCountComp;
